"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var DetailDataSingleLabel = /** @class */ (function (_super) {
    __extends(DetailDataSingleLabel, _super);
    function DetailDataSingleLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        vue_property_decorator_1.Prop({ default: '' })
    ], DetailDataSingleLabel.prototype, "detailLabel", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: [] })
    ], DetailDataSingleLabel.prototype, "detailValue", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: false })
    ], DetailDataSingleLabel.prototype, "isHtml", void 0);
    DetailDataSingleLabel = __decorate([
        vue_property_decorator_1.Component
    ], DetailDataSingleLabel);
    return DetailDataSingleLabel;
}(vue_property_decorator_1.Vue));
exports.default = DetailDataSingleLabel;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/contract_form/DetailDataSingleLabel.vue
// module id = YQ3g
// module chunks = 1